import React, { useState } from 'react';
import { Button, Input, Card, Logo, Checkbox } from '../components/components';
import { PageContainer, Footer } from '../layout/layouts';
import { theme } from '../styles/theme';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    console.log({ email, password, rememberMe });
  };

  return (
    <PageContainer>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, padding: `${theme.spacing.xxl} 0` }}>
        <Logo size="lg" style={{ marginBottom: theme.spacing.xl }} />
        
        <Card style={{ width: '100%', maxWidth: '420px', padding: theme.spacing.lg }} hoverable={false}>
          <h2 style={{ margin: '0 0 8px 0', fontSize: theme.typography.fontSize.xl, color: theme.colors.textPrimary, textAlign: 'center' }}>
            Sign In to OS
          </h2>
          <p style={{ margin: `0 0 ${theme.spacing.lg} 0`, fontSize: theme.typography.fontSize.sm, color: theme.colors.textSecondary, textAlign: 'center' }}>
            Enter your credentials to manage your academy operations.
          </p>

          <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md }}>
            <Input
              type="email"
              label="Email Address"
              placeholder="name@academy.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Input
              type="password"
              label="Password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: theme.typography.fontSize.xs }}>
              <Checkbox label="Remember this device" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
              <a href="/forgot-password" style={{ color: theme.colors.primary, textDecoration: 'none', fontWeight: theme.typography.fontWeight.semibold }}>
                Forgot Password?
              </a>
            </div>

            <Button type="submit" fullWidth style={{ marginTop: theme.spacing.sm }}>
              Access Dashboard
            </Button>
          </form>

          <div style={{ textAlign: 'center', marginTop: theme.spacing.lg, fontSize: theme.typography.fontSize.xs, color: theme.colors.textSecondary }}>
            New institute owner? <a href="/register" style={{ color: theme.colors.primary, textDecoration: 'none', fontWeight: theme.typography.fontWeight.semibold }}>Create Account</a>
          </div>
        </Card>
      </div>
      <Footer />
    </PageContainer>
  );
};

export default Login;
